import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

let reactPlugin: ReactPlugin | null = null;
let appInsights: ApplicationInsights | null = null;

export const createTelemetryService = () => {
    const browserHistory = createBrowserHistory({ basename: '' });
    reactPlugin = new ReactPlugin();
    appInsights = new ApplicationInsights({
        config: {
            instrumentationKey: window.crewPayConfig.appInsightsKey,
            extensions: [reactPlugin],
            extensionConfig: {
                [reactPlugin.identifier]: { history: browserHistory }
            }
        }
    });
    appInsights.loadAppInsights();
};

export const getAppInsights = () => appInsights;
export const getReactPlugin = () => reactPlugin ?? new ReactPlugin();